import React from 'react'
import './index.css'
import { Row, Col, Space, Typography, Flex } from 'antd'
import { Link } from 'react-router-dom'
import { RightOutlined } from '@ant-design/icons'
const { Title, Text } = Typography

const Whoweare = () => {
  const data = [
    {
      key: '1',
      title: 'The best talent',
      description: 'Discover reliable professionals by exploring their portfolios and immersing yourself in the feedback shared on their profiles.'
    },
    {
      key: '2',
      title: 'Fast bids',
      description: 'Get quick, no-obligation quotes from skilled freelancers. 80% of jobs receive bids within 60 seconds. Your idea is just moments from reality.'
    },
    {
      key: '3',
      title: 'Quality work',
      description: 'Discover reliable professionals by exploring their portfolios and immersing yourself in the feedback shared on their profiles.'
    },
    {
      key: '4',
      title: 'The best talent',
      description: 'Discover reliable professionals by exploring their portfolios and immersing yourself in the feedback shared on their profiles.'
    },

  ]
  return (
    <div className='makeitreal-bg padding-t-m padding-main'>
      <div className='container'>
        <Row gutter={[16, 16]} align={'center'} justify={'space-between'}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
            <Title level={1} className='brown-gadient'>Make it real with Freelancer</Title>
            <Row gutter={[16, 16]}>
              {
                data?.map((item, index) => (
                  <Col lg={{ span: 12 }} key={item.key}>
                    <Title level={3} className='text-white'>{item.title}</Title>
                    <Text className='text-white'>{item.description}</Text>
                  </Col>
                ))
              }

            </Row>
            <Title className='mt-3 text-white' level={3}>Make your dreams a reality.</Title>
            <Flex>
              <Link to={'/'} className='fs-16 fw-500 text-brown'>
                Browse jobs
                <RightOutlined style={{ paddingLeft: 5, paddingTop: 2 }} />
              </Link>
            </Flex>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 10 }}>
            <Flex>
              <div className='review-img'>
                <img src="assets/images/choose.png" width={'100%'} height={'auto'} alt="" />
              </div>
            </Flex>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export { Whoweare }